import React, { useEffect } from 'react'
import TruckTable from '../../Components/TruckTable/page'
import Banner2 from '../../Components/Banner/Banner2'

const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="WELCOME TO TRUCK SERIES" backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    {/* <DriverSec3/> */}
    <TruckTable/>
    </>
  )
}

export default Page